export default __webpack_public_path__ + "static/media/AMS2.6f274713.svg";